import React from 'react'
import { content } from 'src/components/menu/my-orders/details/components'
import { CustomCard } from 'src/components'
import { useTranslation } from 'next-i18next'
import { Row, Col, Divider, Typography } from 'antd'
import styles from 'src/components/menu/my-orders/details/MyOrderListDetailsPageContent/MyOrderListDetailsPageContent.module.scss'
const { Title } = Typography

const MyIntegrationOrderDetailsPageContent = ({ loading, order, orderItem, isPrePurchase = false }) => {
  const { t } = useTranslation()
  const isLoading = loading || !order || !orderItem

  return (
    <>
      <CustomCard loading={isLoading}>
        {!isLoading && (
          <>
            <Row>
              <Col xs={24} lg={12} className={styles['boxDetails']}>
                <content.OrderItemDetails order={order} orderItem={orderItem} />
              </Col>
              <Col xs={24} lg={12}>
                <content.OrderItemImage image={orderItem.project_thumbnail} />
              </Col>
            </Row>
            <Divider />
            <Row>
              <Col xs={24} lg={12} className={styles['details-cols-left']}>
                <content.OrderProjectDetails order={order} orderItem={orderItem} />
              </Col>
              <Col xs={24} lg={12} className={styles['details-cols-right']}>
                <content.OrderFeeDetails order={order} orderItem={orderItem} />
              </Col>
            </Row>

            <Divider />
            <Title level={5}>{t('Transactions.Download')}</Title>
            <Row>
              <Col xs={24} lg={12} className={styles['details-cols-left']}>
                <content.OrderItemCertificates order={order} orderItem={orderItem} isPrePurchase={isPrePurchase} />
              </Col>
              <Col xs={24} lg={12} className={styles['details-cols-right']}>
                <content.OrderItemFeeCertificates order={order} orderItem={orderItem} />
              </Col>
            </Row>
          </>
        )}
      </CustomCard>
    </>
  )
}

export default MyIntegrationOrderDetailsPageContent
